<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left list-btn" width="5%">
            <router-link
              :to="{ name: 'bookingsDetail', params: { id: props.item.id } }"
            ><i class="fas fa-search"></i></router-link>
          </td>
          <td class="text-xs-left" width="12%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.hotel.name }}</span><pre>{{ props.item.hotel.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="12%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.user.name }}</span><pre>{{ props.item.user.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="15%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.user.email }}</span><pre>{{ props.item.user.email }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="8%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.status }}</span><pre>{{ props.item.status }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="7%" v-if="props.item.rooms.length === 1"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.rooms[0].name }}</span><pre>{{ props.item.rooms[0].name }}</pre></v-tooltip></td>
          <td class="room-tooltip text-xs-left" width="7%" v-else-if="props.item.rooms.length >= 2">
            <v-tooltip bottom="">
              <v-btn dark color="primary" slot="activator" class="ch-menu-btn ma-0">Rooms</v-btn>
              <span v-for="room in props.item.rooms" :key="room.id">{{ room.name }} </span>
            </v-tooltip>
          </td>
          <td class="text-xs-left" width="7%" v-else></td>
          <td class="text-xs-left" width="7%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.user_type }}</span><pre>{{ props.item.user_type }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.checkin_at | moment("YYYY-MM-DD HH") }}</span><pre>{{ props.item.checkin_at | moment("YYYY-MM-DD HH") }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.checkout_at | moment("YYYY-MM-DD HH") }}</span><pre>{{ props.item.checkout_at | moment("YYYY-MM-DD HH") }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</span><pre>{{ props.item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}</pre></v-tooltip></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { bookingsEventBus } from '@/components/admin/bookings/bookingsEventBus';
  import api from '../../../api';

  export default {
    // TODO: Doorlock 관련 booking이 추가 될 때, props - 'doorlockBookingId'
    props: ['hotelsBookingId', 'storeFilter', 'storePage'],
    data() {
      return {
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        visibleRoomName: false,
        headers: [
          { text: 'View', value: 'booking_id', align: 'left', sortable: false },
          { text: 'Hotel', value: 'hotel', align: 'left', sortable: false },
          { text: 'User Name', value: 'username', align: 'left', sortable: false },
          { text: 'User Email', value: 'useremail', align: 'left', sortable: false },
          { text: 'Status', value: 'status', align: 'left' },
          { text: 'Room', value: 'room_name', align: 'left', sortable: false },
          { text: 'Type', value: 'user_type', align: 'left' },
          { text: 'Checkin At', value: 'checkin_at', align: 'left' },
          { text: 'Checkout At', value: 'checkout_at', align: 'left' },
          { text: 'Updated At', value: 'updated_at', align: 'left' },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['status', 'checkin_at', 'checkout_at', 'updated_at'],
        // NOTE: Data
        listItems: [],    // 실제 서버에서 받아온 원본 리스트
        filter: [],       // 쿼리문을 담을 배열
      };
    },
    methods: {
      /**
       * @description 필터에 정보가 없을경우 최초 한번만 실행,
       * 필터에 정보가 존재할 경우에는 BookingsFilter에서 eventbus 실행됨
       */
      init() {
        if (_.isEmpty(this.storeFilter)) {
          this.getBookingList();
        }
      },
      getBookingList() {
        this.loading = true;
        const sortStr = this.pagination.sortBy;
        let orderStr = null;
        if (this.pagination.descending === null) {
          orderStr = null;
        } else if (this.pagination.descending === false) {
          orderStr = 'asc';
        } else if (this.pagination.descending === true) {
          orderStr = 'desc';
        }
        const querystring = {
          sort: sortStr,
          order: orderStr,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage,
          pagination: true,
        };
        for (let index = 0; index < this.filter.length; index += 1) {
          querystring[this.filter[index].searchCategory] = this.filter[index].search;
        }
        // NOTE: 해당 Hotel의 booking list
        if (this.hotelsBookingId) querystring.hotel_id = this.hotelsBookingId;
        api.getBookingList(querystring)
        .then((result) => {
          if (result.status === 200) {
            // NOTE: item status reassign
            this.listItems = result.data.items.map((item) => {
              const rebuildItem = item;
              switch (rebuildItem.status) {
                case 'created':
                  rebuildItem.status = 'Not assigned';
                  break;
                case 'issued':
                  rebuildItem.status = 'Assigned';
                  break;
                case 'canceled':
                  rebuildItem.status = 'Canceled';
                  break;
                default:
                  rebuildItem.status = '';
                  break;
              }
              return rebuildItem;
            });
            this.totalItems = result.data.total;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.loading = false;
        });
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          if (this.isInit) {
            console.log('handler');
            this.getBookingList();
          }
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    mounted() {
      console.log('bookinglist mount');
      this.init();
      // NOTE: 페이지 로드
      this.$nextTick(() => {
        this.isInit = true;
      });
      this.$nextTick(() => {
        if (!_.isEmpty(this.storePage)) {
          this.pagination = Object.assign({}, this.storePage);
          this.getBookingList();
        }
      });
      bookingsEventBus.$on('initFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getBookingList();
      });
      bookingsEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        // NOTE: 검색조건이 바뀌므로 첫 페이지로 이동
        this.pagination.page = 1;
        this.getBookingList();
      });
      bookingsEventBus.$on('reloadList', () => this.getBookingList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style lang="scss" scoped>
.room-tooltip {
  button {
    box-shadow: none;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/bookings/BookingsList.vue